/** 입찰 › 내 신청 결과 — 상태별로 지금 어떻게 됐는지(10-21 홈 「내 배차 신청」 타일에서 입찰 탭으로 옮김). */

import { type MyBid } from '../lib/driverApi';
import { useDriverList } from '../lib/driverCache';
import Screen, { BidTabs, Empty, ErrorBanner, Loading } from './Screen';
import { when } from './format';

/** 미소비 → 신청중 · 소비+배정 → 확정 · 소비+미배정 → 미선정(노선 자체가 취소면 취소). */
function statusOf(b: MyBid): { label: string; cls: string } {
  if (!b.is_consumed) return { label: '신청중', cls: 'bg-brand-50 text-brand-700' };
  if (b.assigned) return { label: '확정', cls: 'bg-green-50 text-green-700' };
  if (b.dispt_status === '취소') return { label: '취소', cls: 'bg-canvas text-ink-soft' };
  return { label: '미선정', cls: 'bg-canvas text-ink-soft' };
}

export default function MyBids() {
  // 홈에서 미리 받아 둔 목록을 바로 그리고 뒤에서 새로 받는다(lib/driverCache.ts).
  const { data, error } = useDriverList('myBids', '신청 내역을 불러오지 못했습니다.');
  const rows: MyBid[] | null = data?.rows ?? null;

  return (
    <Screen title="입찰 배차">
      <BidTabs active="my-bids" />
      {error && <ErrorBanner>{error}</ErrorBanner>}
      {rows === null ? (
        <Loading />
      ) : rows.length === 0 ? (
        <Empty>아직 신청한 입찰이 없습니다.</Empty>
      ) : (
        <ul className="space-y-4">
          {rows.map((b) => {
            const s = statusOf(b);
            return (
              <li key={b.dispt_car_sch_wait_id} className="driver-card p-5">
                <div className="flex items-start justify-between gap-2">
                  <h2 className="text-lg font-bold text-ink">{b.cust_name || b.dispt_name || '배차'}</h2>
                  <span className={`shrink-0 rounded-lg px-2 py-1 text-sm font-semibold ${s.cls}`}>{s.label}</span>
                </div>
                <dl className="mt-3 space-y-2 text-base">
                  <Row k="출발" v={when(b.start_time)} />
                  <Row k="출발지" v={b.start_loc || '-'} />
                  <Row k="행선지" v={b.end_loc || '-'} />
                  <Row k="신청" v={`${when(b.applied_at)}${(b.apply_cnt ?? 1) > 1 ? ` (${b.apply_cnt}회)` : ''}`} />
                </dl>
              </li>
            );
          })}
        </ul>
      )}
    </Screen>
  );
}

function Row({ k, v }: { k: string; v: string }) {
  return (
    <div className="flex justify-between gap-3">
      <dt className="shrink-0 text-ink-soft">{k}</dt>
      <dd className="text-right font-medium text-ink">{v}</dd>
    </div>
  );
}
